import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';
import { useTkv2HandleIconClick } from './useTkv2HandleIconClick.ts';

export const Tkv2ReconciliationItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'reconciliation' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="reconciliation"
      label="Reconciliation"
      icon="comment"
      isSelected={isSelected}
      onClick={() => handleIconClick('reconciliation')}
      formItem
    />
  );
};
